import { Model } from '@/clients/http'

import { BrandHttpParams, BrandResponses } from '@/types'

export class BrandModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_BRAND_LIST',
    GET_BY_ID: 'GET_BRAND_BY_ID',
    CREATE: 'CREATE_BRAND',
    UPDATE: 'UPDATE_BRAND',
    DELETE: 'DELETE_BRAND',
  }

  public static readonly endpoints = {
    getList: (props?: BrandHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/brand',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: BrandHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/brand/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: BrandHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/brand',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: BrandHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/brand/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: BrandHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/brand/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: BrandHttpParams.GetList) => {
    return this.createHttpRequest<BrandResponses.GetList, BrandResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly getById = async (props: BrandHttpParams.GetById) => {
    return this.createHttpRequest<BrandResponses.GetById, BrandResponses.GetByIdError>({
      correlationKey: this.correlations.GET_BY_ID,
      payload: {
        method: 'get',
        url: this.endpoints.getById(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly create = async (props: BrandHttpParams.Create) => {
    return this.createHttpRequest<BrandResponses.Create, BrandResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly update = async (props: BrandHttpParams.Update) => {
    return this.createHttpRequest<BrandResponses.Update, BrandResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly delete = async (props: BrandHttpParams.Delete) => {
    return this.createHttpRequest<BrandResponses.Delete, BrandResponses.DeleteError>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
